import { Input as AntInput } from 'antd'
import type { ComponentProps } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

type AntInputProps = ComponentProps<typeof AntInput>

export interface AppInputProps extends Omit<AntInputProps, 'size'> {
  size?: Size
}

export const AppInput = ({ size = 'md', ...rest }: AppInputProps) => <AntInput size={SIZE_MAP[size]} {...rest} />
